import type { ReactNode } from 'react'

// Teal-gradient "upcoming lesson" card — the calendar-sidebar equivalent of the dashboard's
// stat cards, so a lesson reads as the thing worth noticing, not just another white list
// row. Used by every portal's calendar page (instructor, school, student).
export function LessonCard({
  title, subtitle, meta, badge, children,
}: {
  title: string
  subtitle?: string
  meta?: string
  badge?: ReactNode
  children?: ReactNode
}) {
  return (
    <div style={{
      background: 'linear-gradient(155deg, #0F7C6C, #0B5D51)', borderRadius: 12,
      padding: '14px 16px', marginBottom: 10,
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 10 }}>
        <div style={{ minWidth: 0 }}>
          <div style={{ font: '600 14px Inter, sans-serif', color: '#fff' }}>{title}</div>
          {subtitle && (
            <div style={{ font: '400 12.5px Inter, sans-serif', color: 'rgba(255,255,255,0.75)', marginTop: 2 }}>
              {subtitle}
            </div>
          )}
        </div>
        {badge}
      </div>
      {meta && (
        <div style={{ font: '400 12.5px Inter, sans-serif', color: 'rgba(255,255,255,0.75)', marginTop: 8 }}>
          {meta}
        </div>
      )}
      {children && (
        <div style={{ display: 'flex', gap: 8, marginTop: 10, flexWrap: 'wrap' }}>
          {children}
        </div>
      )}
    </div>
  )
}

// A white-outline action button meant to sit on the teal LessonCard background —
// the default navy/danger outline buttons used elsewhere lose all contrast there.
export function LessonCardButton({
  label, tone = 'neutral', onClick, disabled,
}: {
  label: string
  tone?: 'neutral' | 'danger'
  onClick: () => void
  disabled?: boolean
}) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      style={{
        padding: '6px 12px', background: tone === 'danger' ? 'rgba(192,82,42,0.35)' : 'rgba(255,255,255,0.14)',
        border: '1px solid rgba(255,255,255,0.4)', borderRadius: 7,
        font: '500 12px Inter, sans-serif', color: '#fff', cursor: disabled ? 'default' : 'pointer',
        opacity: disabled ? 0.6 : 1,
      }}
    >
      {label}
    </button>
  )
}
